export default __webpack_public_path__ + "static/media/icon-refresh.e025e310.svg";